import { gql } from '@grandvisionhq/graphql';

const GET_PREFERRED_STORE_ID = gql`
  query GetPreferredStoreId {
    me {
      id
      preferredStore {
        globalStoreId
        code
      }
    }
  }
`;

export { GET_PREFERRED_STORE_ID };
//# sourceMappingURL=get-preferred-store-id.js.map
